// CSS-in-JS style for login page background
import bgLogin from '../assets/background-login.jpg';

export const loginBgStyles = {
  minHeight: '100vh',
  width: '100vw',
  backgroundImage: `url(${bgLogin})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
